module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1